/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'confluence-table-tree.column.contributors': 'Medarbetare',
  'confluence-table-tree.column.last-modified': 'Senast ändrad',
  'confluence-table-tree.column.title': 'Namn',
  'confluence-table-tree.could-not-load': 'Det gick inte att läsa in',
  'confluence-table-tree.could-not-load-contributors': 'Det gick inte att läsa in medarbetare',
  'confluence-table-tree.create-child-page': 'Skapa en underordnad sida',
  'confluence-table-tree.create-page': 'Skapa sida',
  'confluence-table-tree.default.page.title': 'Utan rubrik',
  'confluence-table-tree.default.show-all-pages-button.label': 'Visa fler sidor',
  'confluence-table-tree.draft.lozenge': 'UTKAST',
  'confluence-table-tree.draft.tooltip': 'Endast du kan se utkast.',
  'confluence-table-tree.drafts-toggle.label': 'Visa utkast',
  'confluence-table-tree.edit': 'Redigera',
  'confluence-table-tree.edit-in-confluence': 'Redigera i Confluence',
  'confluence-table-tree.empty.description':
    'Skapa mötesanteckningar, produktkrav, beslut eller annat innehåll för att fylla utrymmet.',
  'confluence-table-tree.empty.title': 'Här finns inget annat än potential',
  'confluence-table-tree.error.description': 'Vi kan inte visa de här sidorna. Försök igen senare.',
  'confluence-table-tree.error.row': 'Det gick inte att läsa in sidor.',
  'confluence-table-tree.error.title': 'Det var konstigt ...',
  'confluence-table-tree.friendly-when-created': 'Skapad',
  'confluence-table-tree.friendly-when-updated': 'Uppdaterad',
  'confluence-table-tree.share.copied': 'Kopierad till urklipp',
  'confluence-table-tree.share.copy-button': 'Kopiera',
  'confluence-table-tree.share.subtitle': 'Dela denna länk',
  'confluence-table-tree.share.title': 'Dela sida',
  'confluence-table-tree.share.tooltip': 'Dela',
  'confluence-table-tree.view-profile': 'Visa profil',
};
